
import {$axiosGet, $axiosPost} from './http'
// import qs from 'qs';

// 获取下载链接
export function getloadUrl (data) {
  return $axiosGet('/anon/v1/setting/getDownloadUrl.do', data)
}
// 全球合夥人提交資料
export function submitData (data) {
  return $axiosPost('/anon/v1/fedback/add.do', data)
}



// WEBPACK FOOTER //
// ./src/assets/js/api.js